// extracted by mini-css-extract-plugin
module.exports = {"locationSkuCategory":"vs3OE6Tx3+tDfcdC7h3SFQ==","locationSkuCategoryTitle":"wZt7wa860Ep9c+JCoarZCg=="};